@if (drawer(); as active) {
  <button
    type="button"
    class="fixed inset-0 z-100 cursor-default bg-neutral-100/50"
    [class]="closing() ? 'animate-fade-out' : 'animate-fade-in'"
    [attr.aria-label]="'drawer.close' | transloco"
    (click)="onBackdropClick()"
  ></button>
  <div class="pointer-events-none fixed inset-0 z-101 flex justify-end">
    <div
      class="pointer-events-auto flex h-full w-72 flex-col lg:w-100 overflow-y-auto bg-neutral-0 shadow-modal"
      [class]="closing() ? 'animate-drawer-out' : 'animate-drawer-in'"
      cdkTrapFocus
      [cdkTrapFocusAutoCapture]="true"
      role="dialog"
      aria-modal="true"
      (animationend)="onAnimationEnd($event)"
    >
      <ng-container
        [ngComponentOutlet]="active.component"
        [ngComponentOutletInjector]="active.injector"
      />
    </div>
  </div>
}
